import { List as IList } from 'immutable';

export const selectModalVisibility = (state) =>
  state.companyBackgroundSelect.get('modalCompanyBackgroundVisible', false);
export const selectBackgroundImages = (state) =>
  state.companyBackgroundSelect.get('backgroundImages', IList());
